type AppConfig = Record<string, string | undefined>;

declare const __APP_CONFIG__: AppConfig | undefined;

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

const getImportMetaEnv = (): Record<string, string | undefined> => {
  try {
    return ((import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env ?? {});
  } catch {
    return {};
  }
};

const normalizeValue = (value?: string | null): string => {
  if (!value) return '';
  const cleaned = value.replace(/^['"]|['"]$/g, '').trim();
  if (!cleaned || cleaned === 'undefined' || cleaned === 'null') {
    return '';
  }
  return cleaned;
};

export const getEnv = (key: string): string => {
  const importMetaEnv = getImportMetaEnv();
  const appConfig = __APP_CONFIG__ ?? window.__APP_CONFIG__ ?? {};

  return normalizeValue(
    importMetaEnv[key] ??
      importMetaEnv[`VITE_${key}`] ??
      appConfig[key] ??
      appConfig[`VITE_${key}`],
  );
};

export const env = {
  apiBaseUrl: getEnv('API_BASE_URL'),
  googleClientId: getEnv('GOOGLE_CLIENT_ID'),
  googleApiKey: getEnv('GOOGLE_API_KEY'),
  schoolDomain: getEnv('SCHOOL_DOMAIN'),
};
